<template>
    <div id="index2" class="clearfix">
        <div class="center">
            <div class="noread" v-show="showAlarm">
                您有未读内容，点击查看
                <span class="close" @click="closeTitle()"></span>
            </div>
            <div class="newsList">
                <ul>
                    <!-- 无图片 -->
                    <li class="clearfix" v-for="(item,i) in threadlist"  v-if="item.thumbs">
                        <div class="noImg" v-if="item.thumbs&&item.thumbs.length==0">
                            <h3 class="title" @click="intoDetail(item.tid,item.url)">{{item.subject}}</h3>
                            <div class="btm_txt">
                                <span class="tag" v-if="item.tit!=''">{{item.tit}}</span>
                                <img class="avatar" :src="item.avatar?item.avatar:'http://dev.linyouquan.net/imgs/topic/noavatar_big.gif'" alt="">
                                <a  class="msg" href="javascript:;">{{item.author}}·{{item.replies}}评论·{{item.dateline | catipTime}}分钟</a>
                                <i class="close"  @click="closeList(i)"></i>
                            </div>
                        </div>
                    <!-- 左图右字 -->
                        <div class="clearfix" v-if="item.thumbs&&item.thumbs.length>0 &&item.thumbs.length<3 ">
                            <div class="left_img" :style="{backgroundImage:'url('+item.thumbs[0]+')'}">
                                <!-- <img class="l_img" :src="item.thumbs[0]" alt=""> -->
                            </div>
                            <div class="hasOne">
                                <h3 class="title" @click="intoDetail(item.tid,item.url)">{{item.subject}}</h3>
                                <div class="btm_txt">
                                    <span class="tag" v-if="item.tit!=''">{{item.tit}}</span>
                                    <img class="avatar" :src="item.avatar?item.avatar:'http://dev.linyouquan.net/imgs/topic/noavatar_big.gif'" alt="">
                                    <a  class="msg" href="javascript:;">{{item.author}}·{{item.replies}}评论·{{item.dateline | catipTime}}分钟</a>
                                    <i class="close" @click="closeList(i)"></i>
                                </div>
                            </div>
                        </div>
                    <!-- 三张图显示 -->
                        <div class="noImg hasMore" v-if="item.thumbs&&item.thumbs.length>=3 ">
                            <h3 class="title" @click="intoDetail(item.tid,item.url)">{{item.subject}}</h3>
                            <ul class="imgs_list clearfix">
                                <li v-for="(timg,k) in item.thumbs">
                                    <img :src="timg?timg:'http://dev.linyouquan.net/imgs/topic/noavatar_big.gif'" alt="">
                                </li>
                            </ul>
                            <div class="btm_txt">
                                <span class="tag blue" v-if="item.tit!=''">{{item.tit}}</span>
                                <img class="avatar" :src="item.avatar?item.avatar:'http://dev.linyouquan.net/imgs/topic/noavatar_big.gif'" alt="">
                                <a  class="msg" href="javascript:;">{{item.author}}·{{item.replies}}评论·{{item.dateline}}分钟</a>
                                <i class="close" @click="closeList(i)"></i>
                            </div>
                        </div>
                    </li>
                </ul>
            </div>
            <div class="refresh" @click="refresh()">
                4小时前看到这里 点击刷新<img src="~@/assets/imgs/ref.png" alt="·">
            </div>
        </div>
        <div class="right_box">
            <div class="search clearfix">
                <input type="text" class="" v-model="keywords" placeholder="请输入要搜索的内容">
                <a href="javascript:;" class="search_btn" @click="intoSearch(keywords)">搜索</a>
            </div>
            <!-- 登录信息 -->
            <Loginbox></Loginbox>
            <!-- 广告 -->
            <div class="adv_box">
                <div class="imgBox">
                    <el-carousel height="210px">
                        <el-carousel-item v-for="item in 4" :key="item">
                            <img src="http://dev.linyouquan.net/uploads/2019/09/12/VCMCl.jpeg" alt="">
                        </el-carousel-item>
                    </el-carousel>
                    <span class="show">广告</span>
                </div>
            </div>
            
            <!-- 24h热帖 -->
            <Hot></Hot>
            <!-- 热门活动 -->
            <Hotactive></Hotactive>
        </div>
         <!-- <el-pagination
            class="clearfix"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage4"
            :page-sizes="[100, 200, 300, 400]"
            :page-size="100"
            layout="total, sizes, prev, pager, next, jumper"
            :total="400">
        </el-pagination> -->
    </div>
</template>

<script>
import axios from 'axios';
import Hot from '../common/hot'
import Hotactive from '../common/Hotactive'
import Loginbox from '../common/loginBox'
export default {
    filters:{
        catipTime:function(val) {
            if(!val) return ''
            return Math.floor((val/1000)/60/60/60)
        }
    },
    components:{
        Hot,
        Hotactive,
        Loginbox
    },
    data() {
        return {
            threadlist:[],
            currentPage4: 4,
            showAlarm:true,
            keywords:''
        }
    },
    computed:{
    },
    mounted() {
        this.getLists()
    },
    methods:{
        intoSearch(val) {
            this.$router.push({path:`/search?keywords=${val}`})
        },
        closeTitle() {
            this.showAlarm = false
        },
        handleSizeChange(val) {
            console.log(`每页 ${val} 条`);
            router.beforeEach((to, from, next) => {
            })
        },
        handleCurrentChange(val) {
            console.log(`当前页: ${val}`);
        },
        intoDetail(tid,url) {
            let routeData = this.$router.resolve({
                path: `/newsdetail/${tid}`
            });
            if(!tid) {
                window.open(url, '_blank');
            }else{
                window.open(routeData.href, '_blank');
            }
        },
        getLists() {
            axios.get(`${this.commonIp}/v1/home`).then((res) => {
                this.threadlist = res.data.data.threadlist
            })
        },
        // 删除当前一条
        closeList(i) {
            this.threadlist.splice(i,1)
        },
        // 点击刷新
        refresh() {
            
        }
    }
}
</script>
<style lang="less" scoped>
@import '~@/assets/less/index.less';
    #index2{
        width:100%;
        .center{
            margin-left:121px;
            width: 680px;
            .fl();
        }
        .right_box{
            width:280px;
            margin:0 0 0 25px;
            .fr();
            .search{
                height:40px;
                line-height: 40px;
                border:1px solid #ededed;
                width:100%;
                border-radius:5px;
                input{
                    height:100%;
                    border:0;
                    width:80%;
                    background:#f4f5f6;
                    float: left;
                    padding:0 0 0 8px;
                }
                .search_btn{
                    width: 20%;
                    height: 100%;
                    text-align: center;
                    display: inline-block;
                    color:#fff;
                    font-size:@ft20;
                    border-radius:0 5px 5px 0;
                    background:#208bdc;
                }
            }
            .adv_box{
                padding:20px 18px;
                background:@gray;
                .imgBox{
                    border:3px solid #FF4C45;
                    overflow: hidden;
                    width: 100%;
                    height: 210px;
                    text-align: center;
                    position: relative;
                    img{
                        width:auto;
                        vertical-align: middle;
                        height: 100%;
                    }
                    .show{
                        position: absolute;
                        right:0;
                        bottom:0;
                        display: inline-block;
                        font-size:11px;
                        width:42px;
                        height:20px;
                        line-height: 20px;
                        color:#898989;
                        text-align: center;
                        background:rgba(236,236,236,0.9);
                    }
                }
            }
            .hotBox{
                background:@gray;
                padding:20px 18px 8px;
                margin:20px 0;
                border-top:3px solid @green;
                .list_box{
                    .list{
                        cursor: pointer;
                        height:62px;
                        padding:0 0 10px 0;
                        margin:10px 0 0 0;
                        border-bottom:1px solid #e8e8e8;
                        .left{
                            margin:0 10px 0 0;
                            width:52px;
                            height: 52px;
                            text-align: center;
                            overflow: hidden;
                            .fl();
                            img{
                                width: auto;
                                height: 100%;
                                vertical-align: middle;
                            }
                        }
                        .right{
                            .fl();
                            color:#323232;
                            width:182px;
                            font-size:@ft14;
                            overflow: hidden;
                            display:-webkit-box;
                            -webkit-line-clamp:2;
                            -webkit-box-orient:vertical;
                            white-space:normal;
                            margin:6px 0 0 0;
                            &:hover{
                                color:#2d8ed9;
                            }
                        }
                        &:last-child {
                            border-bottom:0;
                        }
                    }
                }
            }
        }
        .post_box{
            width:100%;
            border:1px solid #ededed;
            .name{
                padding:0 20px;
                height:38px;
                font-weight: bold;
                line-height: 38px;
            }
            .area{
                padding:15px 20px;
                background:#f4f5f6;
                color:#5c5c5c;
                .title{
                    font-size:@ft20;
                    height:35px;
                }
                .zword{
                    font-size:@ft14;
                }
            }
            .btm{
                padding:0 0 0 20px;
                height:35px;
                line-height: 35px;
                span{
                    font-size:@ft14;
                }
                .send{
                    width:104px;
                    .fr();
                    display: inline-block;
                    background:#f58c8b;
                    color:#fff;
                    text-align: center;
                    font-size:@ft20;
                    &.active{
                        background:#ed4040;
                    }
                }
            }
        }
        .noread{
            margin:10px 0;
            line-height:28px;
            height:28px;
            text-align:center;
            color:#fff;
            padding:0 10px 0 0;
            background: @lightblue;
            .close{
                display:inline-block;
                width:20px;
                text-align: center;
                height: 15px;
                margin:7px 0 0 0;
                .fr();
                background:url(~@/assets/imgs/close.png) no-repeat right center;
                background-size:12px;
                cursor: pointer;
            }
        }
        .newsList{
            li{
                border-bottom:1px solid #efefef;
                padding:15px 0;
                .hasMore{
                    .imgs_list{
                        li{
                            width:32%;
                            float: left;
                            border-bottom:0;
                            padding:10px 0 0 0;
                            &:nth-child(2n) {
                                margin:0 2%;
                            }
                            img{
                                width:100%;
                                height:162px;
                            }
                        }
                    }
                }
                .tag{
                    color:#ffaa6a;
                    border:1px solid #ffaa6a;
                    padding:0 7px;
                    display: inline-block;
                    border-radius:2px;
                    &.blue{
                        color:@blue;
                        border-color:@blue;
                    }
                }
                .avatar{
                    margin:0 10px;
                    width:20px;
                    height:20px;
                    display: inline-block;
                    vertical-align: top;
                    border-radius:50%;
                }
                .msg{
                    color:#5c5c5c;
                }
                .close{
                    width:10px;
                    height:10px;
                    margin-top:10px;
                    cursor: pointer;
                    .fr();
                    background: url("~@/assets/imgs/close1.png") no-repeat;
                    background-size:10px;
                }
                h3{
                    cursor: pointer;
                    display: -webkit-box;
                    -webkit-line-clamp: 2;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    color:#323232;
                    line-height: 26px;
                    font-weight: bold;
                    font-size:@ft20;
                    max-height: 52px;
                    &:hover{
                        color:#2d8ed9;
                    }
                }
                .btm_txt{
                    font-size:11px;
                    height: 20px;
                    margin:10px 0 0 0;
                    line-height: 20px;
                    padding:0 10px 0 0;
                }
                .left_img{
                    width:135px;
                    height: 90px;
                    text-align: center;
                    overflow: hidden;
                    background-position: center center;
                    background-repeat: no-repeat;
                    background-size: cover;
                    .fl();
                    margin:0 10px 0 0;
                    .l_img{
                        height:100%;
                    }
                }
                .hasOne{
                    .fl();
                    // padding:0 10px 0 0;
                    width:535px;
                }
            }
        }
        .refresh{
            width:100%;
            cursor: pointer;
            height: 30px;
            line-height: 30px;
            text-align: center;
            border:1px solid #8ec4ec;
            background:#eef6fc;
            color:#2d8ed9;
            margin:12px 0;
            img{
                width:14px;
                margin:0 0 0 8px;
                vertical-align: middle;
            }
        }
    }
</style>




// WEBPACK FOOTER //
// src/components/update/update.vue